import type { IHttpMethodType } from 'components/Endpoints/EndpointSettings/Properties';
import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { v4 } from 'uuid';
import type { IRequestExplorerState, IRequestHeader } from './RequestExplorerContext';
import { RequestExplorerContext } from './RequestExplorerContext';
import { extractUrlParams, initRequestExplorerState, requestExplorerReducer } from './RequestExplorerReducer';

const RequestExplorerProvider: FC<
  IContainerChildrenProps & {
    method?: IHttpMethodType;
    url: string;
    params?: Array<[string, string]>;
    headers?: Array<[string, string]>;
    body?: string;
    structureUuid?: string;
    packageVersionUuid?: string;
    authentication?: any;
  }
> = props => {
  const urlParams = extractUrlParams(props.url);
  const propParams = props.params?.map(header => ({
    use: false,
    valid: true,
    key: header[0],
    value: header[1]
  }));

  const emptyState: IRequestExplorerState = {
    sessionUuid: v4(),
    method: 'GET',
    url: '',
    body: '',
    validUrl: true, // empty string would be valid
    authentication: undefined,
    params: [],
    headers: [],
    sessionLog: [],
    variables: []
  };

  const initialState: Partial<IRequestExplorerState> = {
    url: props.url,
    method: props.method,
    params: [...urlParams, ...(propParams || [])],
    headers: props.headers?.map(
      header =>
        ({
          use: true,
          valid: true,
          key: header[0],
          value: header[1]
        }) as IRequestHeader
    ),
    body: props.body,
    responseStructureUuid: props.structureUuid,
    packageVersionUuid: props.packageVersionUuid,
    authentication: props.authentication
  };
  const [state, dispatch] = useReducer(
    requestExplorerReducer,
    initRequestExplorerState({
      ...emptyState,
      ...initialState
    })
  );

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <RequestExplorerContext.Provider value={{ state, dispatch }}>{props.children}</RequestExplorerContext.Provider>
  );
};

export default RequestExplorerProvider;
